export default "__VITE_ASSET__BNu6szvD__"